<template>
    <el-dialog :title="title" :visible.sync="visible" append-to-body destroy-on-close @close="closeDialog">
        <el-form style="margin-left: 10px;margin-right: 10px;">
            <div class="systemTitle">老系统：</div>
            <el-form-item label="线路名称" :label-width="formLabelWidth" style="margin-bottom: 40px;" >
                <el-select v-for="(el,i) in lineList" :key="`${i}_idx`" v-model="el.lineId" filterable placeholder="请选择" style="margin:0 10px 10px 0;" >
                    <el-option v-for="item in oldLine" :key="item.lineId" :label="item.lineName" :value="item.lineId">
                    </el-option>
                </el-select>
                <el-button type="text" size="medium" style="margin-left: 10px;margin-right: 10px;"
                    @click="addOldLineClick">新增
                </el-button>

            </el-form-item>
            <div class="systemTitle">新系统：</div>
            <el-form-item label="出发目的地" :label-width="formLabelWidth">
                <el-select v-model="form.startAreaId" filterable placeholder="请选择" @change="areaChange($event,'start')">
                    <el-option v-for="item in areaList" :key="item.areaManageId" :label="item.areaName"
                        :value="item.areaManageId">
                    </el-option>
                </el-select>
                <span>-</span>
                <el-select v-model="form.endAreaId" filterable placeholder="请选择"  @change="areaChange($event,'end')">
                    <el-option v-for="item in areaList" :key="item.areaManageId" :label="item.areaName"
                        :value="item.areaManageId">
                    </el-option>
                </el-select>
            </el-form-item>
            <el-form-item label="跳转日期" :label-width="formLabelWidth">
                <el-date-picker type="date" placeholder="选择日期" style="width:200px" v-model="form.jumpTime">
                </el-date-picker>
            </el-form-item>
        </el-form>
        <div slot="footer" class="dialog-footer">
            <el-button @click="closeLineEdit">取 消</el-button>
            <el-button type="primary" @click="saveLineConfig">保 存</el-button>
        </div>
    </el-dialog>
</template>

<script>
import dayjs from 'dayjs'
import { pickBy } from 'lodash-es'

export default {
    name: "lineEdit",
    props: {
        title: {
            type: String,
            default: ''
        },
        visible: {
            type: Boolean,
            default: false
        },
        areaList: {
            type: Array,
            default: () => []
        },
        oldLine: {
            type: Array,
            default: () => []
        },
    },
    data() {
        return {
            oldLine: [],
            startAreaList: [],
            areaList: [],
            lineList: [{
                lineId:''
            }],
            form: {
                endAreaId: '',
                endAreaName: '',
                jumpTime: '',
                lineIds: [],
                startAreaId: '',
                startAreaName: ''
            },

        }
    },

    methods: {
        // 关闭dialog病重置数据
        closeDialog(){
            Object.assign(this.$data, this.$options.data())
        },
        // 增加老线路选择框
        addOldLineClick() {
         this.lineList.push({})
        },
        areaChange(e,type) {
            if(!e) {
                return
            }
            const obj = this.areaList.find(i=> i.areaManageId === e)
            if(type ==='start') {
                this.form.startAreaName = obj.areaName
            }
            if(type ==='end') {
                this.form.endAreaName = obj.areaName
            }
        },

        // 保存新增线路配置
        saveLineConfig() {
            const lineIds = this.lineList.map(i=>i.lineId) || []
            const lineIdsFilter = lineIds.filter((s)=> {return s && s.trim()})
            this.form.lineIds = lineIdsFilter
            this.form.jumpTime = dayjs(this.form.jumpTime).format('YYYY-MM-DD 00:00:00')
            if(!this.form.lineIds.length){
                this.$message.error('请先配置老系统线路')
                return
            }
             if(!this.form.startAreaId){
                this.$message.error('请先配置出发地')
                return
            }
            if(!this.form.endAreaId){
                this.$message.error('请先配置目的地')
                return
            }
            if(this.form.startAreaId === this.form.endAreaId){
                this.$message.error('目的地与出发地相同，请修改')
                return
            }
            this.$emit('save', this.form)
        },
       // 取消按钮，关闭弹框
        closeLineEdit() {
            this.visible = false
            this.form = {}
        }

    }

}
</script>

<style lang="scss" scoped>
.systemTitle {
    font-size: 16px;
    font-weight: 800;
    margin-bottom: 10px;
}

span {
    margin: 0 20px;
}
</style>